import { Route } from "components/Route";
import { Switch } from "react-router-dom";
import { routes } from "routes";
import { AssignmentDetailPage } from "./AssignmentDetailPage";
import { AssignmentsDashboardPage } from "./AssignmentsDashboardPage";
import { CreateAssignmentPage } from "./CreateAssignmentPage";

export const AssignmentManagementSwitch = (): JSX.Element => (
	<Switch>
		<Route path={routes._.assignments._.create.path}>
			<CreateAssignmentPage mode="create" />
		</Route>

		<Route path={routes._.assignments._.view.path}>
			<AssignmentDetailPage />
		</Route>

		<Route path={routes._.assignments._.edit.path}>
			<CreateAssignmentPage mode="edit" />
		</Route>

		<Route path={routes._.assignments.path}>
			<AssignmentsDashboardPage />
		</Route>
	</Switch>
);
